import { useTranslation } from 'react-i18next';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>{t('error.notFoundTitle')}</h1>
      <p>{t('error.notFoundMessage')}</p>
      <a href="/" style={{ color: '#8C1843', textDecoration: 'underline' }}>
        {t('error.backHome')}
      </a>
    </div>
  );
};
